// extracted by mini-css-extract-plugin
export default {"wrapper":"Th2hyd-htjZIf8jqGb6TIQ==","video":"D2++m0P9AtYZ-8VXJzA+-w==","fallback":"bbxwWpJVkNedCToMzIoVKQ==","overlay":"R9qtNVCqR-kbtLNJ4NKf9w=="};